/**
 * 検索フィルタをデフォルト条件に戻し、即時検索を実行する。
 */
export function resetFiltersToDefault({
  defaults,
  setFilters,
  setAppliedFilters,
  updateSearchParams,
}) {
  const next = { ...defaults };
  setFilters(next);
  setAppliedFilters(next);
  updateSearchParams(next);
}
